<datex-grid #$gridComponent *ngIf="initialized "  [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"



>
    <ng-container topToolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch"
        matTooltipClass="datex-control-tooltip">
    </div>
  </ng-container>

  <ng-container filters>
    <div class="fieldsetsContainer" [formGroup]="formGroup">
      <div class="fieldsetsGroup">
      <div data-cy="field-id-date_filter" *ngIf="!filters.date_filter.hidden && !filters.date_filter.removed" 
            class="field-container standard {{filters.date_filter.invalid ? 'invalid' : ''}} {{filters.date_filter.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.date_filter.styles.style"
            [ngClass]="filters.date_filter.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.date_filter.label + (filters.date_filter.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.date_filter.label}}<span *ngIf="filters.date_filter.required" class="required-asterisk">*</span>
          </label>
        </div>
        <Surveys-date_filter_dd_single 
            data-cy="selector"
            [type]="filters.date_filter.control.type"
            formControlName="date_filter"
            (displayTextChange)="filters.date_filter.control.displayText=$event"
            [placeholder]="filters.date_filter.control.placeholder"
            [styles]="filters.date_filter.control.styles"
            [tooltip]="filters.date_filter.control.tooltip"
        >
        </Surveys-date_filter_dd_single>
        <ng-container *ngIf="filters.date_filter.invalid">
          <ng-container *ngFor="let error of filters.date_filter.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-from_date" *ngIf="!filters.from_date.hidden && !filters.from_date.removed" 
            class="field-container standard {{filters.from_date.invalid ? 'invalid' : ''}} {{filters.from_date.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.from_date.styles.style"
            [ngClass]="filters.from_date.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.from_date.label + (filters.from_date.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.from_date.label}}<span *ngIf="filters.from_date.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="from_date"
            [format]="filters.from_date.control.format"
            [mode]="filters.from_date.control.mode"
            [ngStyle]="filters.from_date.control.styles.style"
            [ngClass]="filters.from_date.control.styles.classes"
            [tooltip]="filters.from_date.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.from_date.invalid">
          <ng-container *ngFor="let error of filters.from_date.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      <div data-cy="field-id-to_date" *ngIf="!filters.to_date.hidden && !filters.to_date.removed" 
            class="field-container standard {{filters.to_date.invalid ? 'invalid' : ''}} {{filters.to_date.control.disabled ? 'field-container-disabled' : ''}}"
            [ngStyle]="filters.to_date.styles.style"
            [ngClass]="filters.to_date.styles.classes">
        <div class="label-container"
             [matTooltip]="filters.to_date.label + (filters.to_date.required ? ' (required)' : '')"
             matTooltipClass="datex-control-tooltip">
          <label data-cy="field-label" class="datex-label">{{filters.to_date.label}}<span *ngIf="filters.to_date.required" class="required-asterisk">*</span>
          </label>
        </div>
        <app-datebox 
            data-cy="dateBox"
            formControlName="to_date"
            [format]="filters.to_date.control.format"
            [mode]="filters.to_date.control.mode"
            [ngStyle]="filters.to_date.control.styles.style"
            [ngClass]="filters.to_date.control.styles.classes"
            [tooltip]="filters.to_date.control.tooltip">
        </app-datebox>
        <ng-container *ngIf="filters.to_date.invalid">
          <ng-container *ngFor="let error of filters.to_date.errors">
            <span class="invalid-message">
              {{error}}
            </span>
          </ng-container>
        </ng-container>
      </div>      </div>
    </div>
  </ng-container>

  <ng-container gridColumnDef="survey_definition">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.survey_definition.displayControl.styles.style"
          [ngClass]="row.cells.survey_definition.displayControl.styles.classes"
          [matTooltip]="row.cells.survey_definition.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.survey_definition.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="entity">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.entity.displayControl.styles.style"
          [ngClass]="row.cells.entity.displayControl.styles.classes"
          [matTooltip]="row.cells.entity.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.entity.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="operation_context_type">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.operation_context_type.displayControl.styles.style"
          [ngClass]="row.cells.operation_context_type.displayControl.styles.classes"
          [matTooltip]="row.cells.operation_context_type.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.operation_context_type.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="created_on">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.created_on.displayControl.styles.style"
          [ngClass]="row.cells.created_on.displayControl.styles.classes"
          [matTooltip]="row.cells.created_on.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.created_on.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="created_by">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.created_by.displayControl.styles.style"
          [ngClass]="row.cells.created_by.displayControl.styles.classes"
          [matTooltip]="row.cells.created_by.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.created_by.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="completed_on">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.completed_on.displayControl.styles.style"
          [ngClass]="row.cells.completed_on.displayControl.styles.classes"
          [matTooltip]="row.cells.completed_on.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.completed_on.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="completed_by">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.completed_by.displayControl.styles.style"
          [ngClass]="row.cells.completed_by.displayControl.styles.classes"
          [matTooltip]="row.cells.completed_by.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.completed_by.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="equipment">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.equipment.displayControl.styles.style"
          [ngClass]="row.cells.equipment.displayControl.styles.classes"
          [matTooltip]="row.cells.equipment.displayControl.tooltip"
          matTooltipClass="datex-control-tooltip">{{row.cells.equipment.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
